// src/components/SubscriptionCard.js

import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { styled } from '@mui/system';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark transparent color to match Option 3
  borderRadius: '16px',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Light shadow for better integration
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: '0 4px 25px rgba(0, 0, 0, 0.3)', // Slightly darker shadow on hover
  },
  height: '100%',
}));

const CardHeader = styled(CardContent)({
  textAlign: 'center',
});

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  marginBottom: '8px',
}));

const Price = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
  marginBottom: '16px',
}));

const FeatureList = styled(List)({
  padding: 0,
});

const SubscribeButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: '#fff',
  borderRadius: '8px',
  padding: '10px 20px',
  fontSize: '1rem',
  transition: 'background-color 0.3s ease, transform 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.custom.magentaHazeHover,
    transform: 'scale(1.05)', // Slightly enlarges on hover
  },
}));

const SubscriptionCard = ({ option, onSubscribe }) => {
  return (
    <StyledCard>
      <CardHeader>
        <Title variant="h5">{option.title}</Title>
        <Price variant="h4">{option.amount} SOL/year</Price> {/* Updated to use 'amount' */}
      </CardHeader>
      <CardContent>
        <FeatureList>
          {option.features.map((feature, index) => (
            <ListItem key={index} disableGutters>
              <ListItemIcon>
                <CheckCircleIcon sx={{ color: 'primary.main' }} />
              </ListItemIcon>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </FeatureList>
      </CardContent>
      <CardActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
        <SubscribeButton type="button" onClick={() => onSubscribe(option)}>
          Subscribe
        </SubscribeButton>
      </CardActions>
    </StyledCard>
  );
};

SubscriptionCard.propTypes = {
  option: PropTypes.shape({
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired, // Updated from 'price'
    collections: PropTypes.number.isRequired,
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  onSubscribe: PropTypes.func.isRequired,
};

export default SubscriptionCard;

